import { render } from "./BetaChip.vue?vue&type=template&id=203c9eee&scoped=true"
import script from "./BetaChip.vue?vue&type=script&lang=js"
export * from "./BetaChip.vue?vue&type=script&lang=js"

import "./BetaChip.vue?vue&type=style&index=0&id=203c9eee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203c9eee"]])

export default __exports__